import { ExpandableSection } from "../ExpandableSection";
import { Table } from "../Table";

const Section = ({ items, classes }) =>
  items?.length > 0 && (
    <ExpandableSection title="Clicks on Call to Action (CTA)" classes={classes}>
      <Table
        classes={classes}
        columns={tableColumns}
        items={items.toSorted((a, b) => b.eventCount - a.eventCount)}
        keyField="ctaCategory"
      />
    </ExpandableSection>
  );

const ctaCategoryLabels = {
  videoPlay: "Video Plays",
  contestParticipation: "Participation in the Contest",
  redirectToProduct: "Redirect to Product",
  redirectToPage: "Redirect to Page",
};

const tableColumns = [
  {
    xs: 9,
    sm: 9,
    md: 9,
    label: "CTA category",
    field: "ctaCategory",
    render: (data) => ctaCategoryLabels[data.ctaCategory] || data.ctaCategory,
  },
  { xs: 3, sm: 3, md: 3, label: "Clicks", field: "eventCount" },
];

export default Section;
